import { render, staticRenderFns } from "./ConfiguracionPeso.vue?vue&type=template&id=545e4ef1&scoped=true&"
import script from "./ConfiguracionPeso.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionPeso.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionPeso.vue?vue&type=style&index=0&id=545e4ef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e4ef1",
  null
  
)

export default component.exports